import { canv } from "@/canv/global.js";
import { getTarget } from "@/canv/utils.js";
import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { wmBase } from "@/widgetMenu/wmBase";

const SVG_ICONS: Record<string, string> = {
    left: `<svg class="svg" width="32" height="32" viewBox="0 0 32 32"><path d="M10 22.5H9v-13h1v13zm12-8H12v-2h10v2zm-10 5h6v-2h-6v2z" fill-rule="evenodd" fill-opacity="1" fill="#000" stroke="none"></path></svg>`,
    hCenters: `<svg class="svg" width="32" height="32" viewBox="0 0 32 32"><path d="M16.5 9.5h-1v3h-5v2h5v3h-3v2h3v3h1v-3h3v-2h-3v-3h5v-2h-5v-3z" fill-rule="evenodd" fill-opacity="1" fill="#000" stroke="none"></path></svg>`,
    right: `<svg class="svg" width="32" height="32" viewBox="0 0 32 32"><path d="M22 22.5h1v-13h-1v13zm-12-8h10v-2H10v2zm10 5h-6v-2h6v2z" fill-rule="evenodd" fill-opacity="1" fill="#000" stroke="none"></path></svg>`,
    top: `<svg class="svg" width="32" height="32" viewBox="0 0 32 32"><path d="M14.5 22V12h-2v10h2zm8-12V9h-13v1h13zm-3 2v6h-2v-6h2z" fill-rule="evenodd" fill-opacity="1" fill="#000" stroke="none"></path></svg>`,
    vCenters: `<svg class="svg" width="32" height="32" viewBox="0 0 32 32"><path d="M12.5 15.5v-5h2v5h3v-3h2v3h3v1h-3v3h-2v-3h-3v5h-2v-5h-3v-1h3z" fill-rule="evenodd" fill-opacity="1" fill="#000" stroke="none"></path></svg>`,
    bottom: `<svg class="svg" width="32" height="32" viewBox="0 0 32 32"><path d="M14.5 10v10h-2V10h2zm8 12v1h-13v-1h13zm-3-2v-6h-2v6h2z" fill-rule="evenodd" fill-opacity="1" fill="#000" stroke="none"></path></svg>`,
};

export class WmAlign extends wmBase {
    constructor(options: widgetOption[]) {
        super();
        this.options = options;
    }

    build() {
        return `
            <div class="wm_align">
                ${SVG_ICONS.left}
            </div>
        `;
    }

    init() {
        const item = document.querySelector<HTMLElement>(".wm_align");
        if (!item) return;

        item.removeEventListener("mousedown", this.showSubMenu);
        item.addEventListener("mousedown", this.showSubMenu);
    }

    showSubMenu = (e: MouseEvent) => {
        const existingSubmenu = document.querySelector<HTMLElement>(".wm_align_submenu");
        if (existingSubmenu) {
            existingSubmenu.remove();
            return;
        }

        const otherSubmenu = document.querySelector<HTMLElement>(".widgetSubMenu");
        if (otherSubmenu) otherSubmenu.remove();

        canv.widgetMenu.subMenuBoss = "wm_align";

        const submenu = document.createElement("div");
        submenu.classList.add("widgetSubMenu", "wm_align_submenu");
        submenu.style.opacity = "0";
        document.body.prepend(submenu);

        ["left", "hCenters", "right", "top", "vCenters", "bottom"].forEach((type) => {
            submenu.innerHTML += this.submenuTemplate(type);
        });

        submenu.querySelectorAll<HTMLElement>(".wm_align_submenu_item").forEach((item) => {
            item.removeEventListener("click", this.itemClick);
            item.addEventListener("click", this.itemClick);
        });

        setTimeout(() => canv.widgetMenu.TryLocateMenu(), 50);
    };

    itemClick = (e: MouseEvent) => {
        const item = getTarget(e, "wm_align_submenu_item");
        const align = item.getAttribute("alignType");
        if (!align) return;

        canv.canvasController.alignSelected(align);

        const otherSubmenu = document.querySelector<HTMLElement>(".widgetSubMenu");
        if (otherSubmenu) otherSubmenu.remove();

        canv.redraw();
    };

    submenuTemplate(type: keyof typeof SVG_ICONS) {
        return `
            <div class="wm_align_submenu_item" alignType="${type}">
                ${SVG_ICONS[type]}
            </div>
        `;
    }

    name = "wm_align";
    options: widgetOption[] = [];
    isStriked = false;
}
